/**
 * 实验室原表录入引擎 — 单一数据源：form_templates/GSYN-*.json
 * 不再为每张表写独立 Vue 组件。
 */
import formFkMaps from '../../../config/form_fk_maps.json'

const tplCache = {}

/** 从 JSON 或 config/form_fk_maps.json 解析 Word fk → 存储字段 */
export function resolveFormFk(tpl, fk, formNum) {
  if (!fk) return fk
  if (fk === '__xmbh__' || fk === '__ypbh__') return fk
  const fromTpl = tpl && tpl._fkMap && tpl._fkMap[fk]
  if (fromTpl) return fromTpl
  const num = formNum || (tpl && tpl.bh && tpl.bh.match(/\d{3}/)?.[0]) || ''
  const map = (formFkMaps && formFkMaps[num]) || {}
  return map[fk] || fk
}

export function layoutFromTpl(tpl) {
  return (tpl && tpl._layout) || null
}

export function formHasPaperLayout(tpl, scope) {
  const layout = layoutFromTpl(tpl)
  if (!layout || !tpl.tables || !tpl.tables[0]) return false
  if (scope === 'batch') return (layout.batchEnd || 0) > 0
  if (scope === 'sample') {
    return layout.sampleHeader != null && layout.sampleData != null
  }
  return (layout.batchEnd || 0) > 0 ||
    (layout.sampleHeader != null && layout.sampleData != null)
}

export async function paperFormCaps(formNum) {
  const tpl = await loadFormTemplate(formNum)
  if (!tpl) return { batch: false, sample: false }
  return {
    batch: formHasPaperLayout(tpl, 'batch'),
    sample: formHasPaperLayout(tpl, 'sample')
  }
}

export function formTitle(tpl) {
  if (!tpl) return ''
  const bh = tpl.bh || ''
  const mc = tpl.mc || ''
  return bh && mc ? `${bh} ${mc}` : bh || mc
}

export function rowsForScope(tpl, scope) {
  const table = (tpl && tpl.tables && tpl.tables[0]) || []
  const layout = layoutFromTpl(tpl)
  if (!layout) return []
  if (scope === 'batch') {
    const end = layout.batchEnd != null ? layout.batchEnd : table.length
    return table.slice(0, end)
  }
  if (scope === 'sample') {
    const hi = layout.sampleHeader
    const di = layout.sampleData
    const header = table[hi]
    const data = table[di]
    return header && data ? [header, data] : []
  }
  return table
}

export function colWeightsFromRows(rows, totalCols) {
  const weights = Array(totalCols).fill(1)
  for (const row of rows) {
    let col = 0
    for (const cell of row) {
      const cs = cell.cs || cell.colspan || 1
      for (let i = 0; i < cs && col + i < weights.length; i++) {
        weights[col + i] = Math.max(weights[col + i], cs)
      }
      col += cs
    }
  }
  return weights
}

/** 仪器名称选中后联动的兄弟字段 */
export function instrumentSiblingKeys(yqmcKey) {
  const k = String(yqmcKey || '')
  if (!k) return null
  const m = k.match(/^(.+)_yqmc$/)
  if (m) {
    const p = m[1]
    return { code: `${p}_yqbh`, trace: `${p}_yqsyfs`, expiry: `${p}_yqxyxq` }
  }
  if (k === 'yqmc') {
    return { code: 'yqbh', trace: 'yqsyfs', expiry: 'yqxyxq' }
  }
  const bal = balanceSiblingKeys(k)
  if (bal) return bal
  return null
}

/** 天平型号/名称选中后联动的兄弟字段 */
export function balanceSiblingKeys(nameKey) {
  const k = String(nameKey || '')
  if (!k) return null
  const m = k.match(/^(.+)_(tpxh|tpmc)$/)
  if (m) {
    const p = m[1]
    return { code: `${p}_tpbh`, trace: `${p}_tpsyfs`, expiry: `${p}_tpyxrq` }
  }
  if (k === 'tpxh' || k === 'tpmc') {
    return { code: 'tpbh', trace: 'tpsyfs', expiry: 'tpyxrq' }
  }
  return null
}

/** 根据 registry 字段推断仪器下拉类别 */
export function instrumentCategoryForKey(storageKey, formNum) {
  const k = String(storageKey || '')
  if (k.includes('gcms') || k.includes('gc_') || formNum === '041' || formNum === '127') return 'gc'
  if (k.includes('hplc')) return 'hplc'
  if (k.includes('icpms')) return 'icpms'
  if (k.includes('icpoes')) return 'icpoes'
  if (k.includes('aas')) return 'aas'
  if (k.includes('afs')) return 'afs'
  if (/^yqmc$/.test(k) && (formNum === '005' || formNum === '006')) return 'ph'
  if (/tpxh|tpmc|tpbh|tpsyfs|tpyxrq|tpyxyxq/.test(k)) return 'balance'
  return 'gc'
}

export async function loadFormTemplate(formNum) {
  const num = String(formNum || '').replace(/\D/g, '')
  if (!num) return null
  if (tplCache[num]) return tplCache[num]
  try {
    const res = await fetch(`/form_templates/GSYN-${num}.json`)
    if (!res.ok) return null
    const tpl = await res.json()
    tplCache[num] = tpl
    return tpl
  } catch (e) {
    return null
  }
}

export async function checkPaperForm(formNum) {
  return paperFormCaps(formNum)
}

export function clearTemplateCache() {
  Object.keys(tplCache).forEach(k => { delete tplCache[k] })
}
